import React from 'react'
import HTML5Backend, { NativeTypes } from 'react-dnd-html5-backend'
import { DropTarget, DndProvider } from 'react-dnd'

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';


export const Panel = ({
    accepts,
    isOver,
    canDrop,
    connectDropTarget,
    lastDroppedItem,
  }) => {
    return connectDropTarget(
        <div style={{margin:'20px'}}>
            <Paper style={{height:'40vh',paddingTop:'10vh',paddingLeft:'3em',backgroundColor:isOver?'#77FF00':canDrop?'#DDFF77':'#ddd'}} elevation={isOver?20:canDrop?10:1}>
                <Typography variant='h5' component='h3'>
                    Drag one or more file(s) here to upload
                </Typography>
            </Paper>
        </div>
    )
  }

  export const DropPanel = DropTarget(
    props => props.accepts,
    {
        drop(props,monitor){
            props.onDrop(props,monitor)
        },
    },
    (connect,monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
    }),
)(Panel)

export default class DrapToUpload extends React.Component{
    constructor(props){
        super(props);

        this.handleDrop = this.handleDrop.bind(this);
    }
    handleDrop(item, monitor) {
        if(this.props.onUpload){
            this.props.onUpload(monitor.getItem().files);
        }
    }
    render(){
        return(
            <div>
                <DndProvider backend={HTML5Backend}>
                    <DropPanel accepts={[NativeTypes.FILE, NativeTypes.URL]} lastDroppedItem={null} onDrop={this.handleDrop} />
                </DndProvider>
            </div>
        );
    }
}